import * as api from '../api/returnToApplication'
import { CheckEmailIsAssociatedWithDasherSuccessPayload } from '../api/returnToApplication'
import { CHECK_EMAIL_IS_ASSOCIATED_WITH_DASHER, TRIGGER_SMS_RECOVERY } from '.'

/**
 * Checks if the email provided is associated with a
 * Dasher (not Dasher Applicant) account
 * @param email {string} Email to check
 * @returns {boolean} Whether a Dasher is associated or not
 **/
export const checkEmailIsAssociatedWithDasher = (email: string) => async (
  dispatch
): Promise<CheckEmailIsAssociatedWithDasherSuccessPayload> => {
  dispatch({ type: CHECK_EMAIL_IS_ASSOCIATED_WITH_DASHER.IN_PROGRESS })
  try {
    // Make API call
    const data: CheckEmailIsAssociatedWithDasherSuccessPayload = await api.checkEmailIsAssociatedWithDasher(
      email
    )

    dispatch({ type: CHECK_EMAIL_IS_ASSOCIATED_WITH_DASHER.SUCCESS })
    return data
  } catch (error) {
    dispatch({ type: CHECK_EMAIL_IS_ASSOCIATED_WITH_DASHER.FAIL })
    return {
      shouldForwardToLogin: false,
      applicantUniqueLink: null,
    }
  }
}

/**
 * Triggers an sms message to recover the email associated with a phone number
 * @param phoneNumber Phone number to recover email for
 * @returns call succeeded without errors
 **/
export const sendSmsRecovery = (phoneNumber: string) => async dispatch => {
  dispatch({ type: TRIGGER_SMS_RECOVERY.IN_PROGRESS })
  try {
    await api.sendSmsRecovery(phoneNumber)

    dispatch({ type: TRIGGER_SMS_RECOVERY.SUCCESS })
    return true
  } catch (error) {
    dispatch({ type: TRIGGER_SMS_RECOVERY.FAIL })
    return false
  }
}
